<template>
  <div class="content-card-counter-1">
    <img class="content-card-counter-1-image" :src="content.thumbnail" :alt="content.title">
    <h6 class="content-card-counter-1-title">{{ content.title }}</h6>
    <m-animated-counter class="content-card-counter-1-counter" :counter-value="counterValue()" :duration-prop="durationProp"/>
  </div>
</template>

<script>
import {CardComputed} from "./CardComputed";
import mA from '../../Tags/A'
import mAnimatedCounter from "../../Animated/Counter/AnimatedCounter";
import {AnimatedCounterProps} from "../../Animated/Counter/AnimatedCounterProps";

export default {
  name: "ContentCardCounter1",
  components: {mA, mAnimatedCounter},
  props: {
    content: {},
    ...AnimatedCounterProps
  },
  methods: {
    findNumber(text) {
      var r = /\d+/;
      const number = text.match(r)
      if (number == null) {
        return 0
      }
      return number[0] == null ? 0 : number[0]
    },
    counterValue() {
      if (this.content.abstraction) {
        return this.findNumber(this.content.abstraction);
      }
      return 0
    }
  },
  computed: {
    ...CardComputed,
  },
}
</script>

<style scoped>
.content-card-counter-1-image {
  height: 350px;
  width: 100%;
  object-fit: contain;
}
</style>